import { AxiosInstance } from "axios";
import {
  GetDemographicGroupsResponse,
  GetQuestionBreakdownResponse,
  GetSurveyChapterInsightResponse,
  GetSurveyChapterScoringResponse,
  GetSurveyDemographicResponse,
  GetSurveyScoringDemographicResponse,
} from "../types/workplaceCulture";
import { OVERVIEW_DEMOGRAPHIC_GROUP_ID } from "../utils/WorkplaceCulture.utils";
import { getApiClient } from "../utils/api.utils";

export class WorkplaceCultureService {
  client: AxiosInstance;

  constructor() {
    this.client = getApiClient();
  }

  getSurveyScoring = async (dispatchToken: string, filterId?: string) => {
    const response = await this.client.get<GetSurveyScoringDemographicResponse>(
      `/workplace-culture/${dispatchToken}/scoring/${
        filterId && filterId !== OVERVIEW_DEMOGRAPHIC_GROUP_ID
          ? `?demographic_scope=${filterId}`
          : ""
      }`
    );

    return response.data;
  };

  getSurveyChapterScoring = async (
    dispatchToken: string,
    filterId?: string
  ) => {
    const response = await this.client.get<GetSurveyChapterScoringResponse>(
      `/workplace-culture/${dispatchToken}/scoring/chapters${
        filterId && filterId !== OVERVIEW_DEMOGRAPHIC_GROUP_ID
          ? `?demographic_scope=${filterId}`
          : ""
      }`
    );

    return response.data;
  };

  getSurveyQuestionsScoring = async (dispatchToken: string) => {
    const response = await this.client.get<GetQuestionBreakdownResponse>(
      `/workplace-culture/${dispatchToken}/scoring/questions`
    );

    return response.data;
  };

  getSurveyDemographics = async (dispatchToken: string) => {
    const response = await this.client.get<GetSurveyDemographicResponse>(
      `/workplace-culture/${dispatchToken}/engagement/`
    );

    return response.data;
  };

  getSurveyChapterInsights = async (dispatchToken: string) => {
    const response = await this.client.get<GetSurveyChapterInsightResponse>(
      `/workplace-culture/${dispatchToken}/insights/chapters/`
    );

    return response.data;
  };

  getDemographicGroups = async (dispatchToken: string) => {
    const response = await this.client.get<GetDemographicGroupsResponse>(
      `/workplace-culture/${dispatchToken}/demographic-groups/`
    );

    return response.data;
  };
}
